import { Switch } from "react-router";
import { useSelector } from "react-redux";
import Auth from "./components/auth/Auth";
import Home from "./components/home/Home";
import ApiSetting from "./components/settings/Api-setting";
import Header from "./components/shared/Header";
import { Footer } from "./components/shared/Footer";
import ResetPassword from "./components/auth/pages/ResetPassword";
import PublicRoute from "./components/routes/PublicRoute";
import PrivateRoute from "./components/routes/PrivateRoute";
import Create from "./components/campaign/Create";
import CampaignEditor from "./components/campaign/CampaignEditor";
import AudioList from "./components/campaign/Audio/Audio-List";
import RenderProcess from "./components/campaign/Render/Render";
import ListScens from "./components/Templates/ListTemplates/List-Scenes";
import Users from "./components/users/Users";
import NotFound from "./components/404";
import CreateUser from "./components/users/UserCreate";
import UserProfile from "./components/users/User-profile";
import EasySort from "./components/campaign/Easy-sort";
import Pesonalize from "./components/personalize/Pesonalize";
import ListLandingPage from "./components/landingpage/List-landingPage";
import EditLanding from "./components/landingpage/Edit-landing";
import VideoBackgroundModal from "./components/campaign/VideoBackgroundModal";
import Analytics from "./components/personalize/Analytics";
import DFY from "./components/shared/DFY";
import Support from "./components/shared/Support";
import Bonus from "./components/shared/Bonus";
import LeadAmazeBonus from "./components/shared/LeadAmazeBonus";
import Tutorials from "./components/shared/Tutorials";
import UpgradeAccess from "./components/auth/pages/UpgradeAccess";
import Bump from "./components/shared/Bump";
import MasterClass from "./components/shared/MasterClass";

const AppRouting = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user_roles = useSelector((state) => state.auth.roles);

  var PERMITTED_DOMAIN = "https://ezleadz.app";
  /**
   * Receiving message from other domain
   */
  window.addEventListener('message', function(event) {
      if (event.origin === PERMITTED_DOMAIN) {
          //var msg = JSON.parse(event.data);
          // var msgKey = Object.keys(msg)[0];
          if (event.data) {
              localStorage.setItem("vidamaze_user", JSON.parse(event.data).vidamaze_user);
              localStorage.setItem("vidamaze_ezdata", JSON.parse(event.data).ezData);
              
          } else {
              localStorage.removeItem("vidamaze_user");
              localStorage.setItem("vidamaze_ezdata");
          }
      }
  });
  // console.log("hii here");

  return (
    <>
      {isAuthenticated && <Header />}
      <Switch>
        <PublicRoute restricted={true} component={Auth} path="/login" exact />
        <PublicRoute component={EasySort} path="/sort" exact />
        <PublicRoute
          restricted={true}
          component={Auth}
          path="/forgot_password"
          exact
        />
        <PublicRoute
          restricted={true}
          component={ResetPassword}
          path="/resetPassword"
          exact
        />

        <PrivateRoute
          restricted={true}
          component={UpgradeAccess}
          path="/upgrade-access/:plan"
          exact
        />
        <PrivateRoute component={Home} path="/" exact />
        <PrivateRoute component={Home} path="/dashboard" exact />
        <PrivateRoute component={Home} path="/dashboard/:page_no" exact />

        <PrivateRoute component={ApiSetting} path="/settings" />
        <PrivateRoute component={Create} path="/create-campaign" exact />
        <PrivateRoute
          component={AudioList}
          path="/campaign/:camp_id/audio"
          exact
        />

        <PrivateRoute
          component={CampaignEditor}
          path="/campaign/:camp_id/edit"
          exact
        />

        <PrivateRoute
          component={Analytics}
          path="/campaign/analytics/:camp_id/"
          exact
        />

        <PrivateRoute
          component={Pesonalize}
          path="/video/view/:camp_id"
          exact
        />

        <PrivateRoute
          component={ListScens}
          path="/campaign/:camp_id/list-templates"
          exact
        />

        <PrivateRoute component={DFY} path="/dfy" exact />

        {/* 23-02-2022 */}
        <PrivateRoute
          component={ListLandingPage}
          path="/select-landing/:camp_id"
          exact
        />

        <PrivateRoute
          component={EditLanding}
          path="/:camp_id/edit-landing"
          exact
        />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/create-user"
          exact
        />

        <PrivateRoute
          component={Support}
          user_roles={user_roles}
          path="/support"
          exact
        />

        <PrivateRoute
          component={Tutorials}
          user_roles={user_roles}
          path="/tutorials"
          exact
        />

        <PrivateRoute
          component={Bonus}
          user_roles={user_roles}
          path="/bonus"
          exact
        />

        <PrivateRoute 
          component={LeadAmazeBonus}
          user_roles={user_roles}
          path="/leadamaze"
          exact
        />

        <PrivateRoute 
          component={MasterClass} 
          user_roles={user_roles}
          path="/masterclass" 
          exact 
        />

        <PrivateRoute 
          component={Bump} 
          user_roles={user_roles}
          path="/bump" 
          exact 
        />

        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users"
          exact
        />

        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users/:page_no"
          exact
        />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/users/edit/:user_id"
          exact
        />

        {/* 6-4-2022 */}
        <PrivateRoute
          component={VideoBackgroundModal}
          user_roles={user_roles}
          path="/campaign/:camp_id/video-gallery"
        />

        <PrivateRoute component={UserProfile} path="/profile" exact />

        <PrivateRoute component={RenderProcess} path="/render/:camp_id" exact />

        <PublicRoute component={NotFound} path="" />
        <PrivateRoute component={NotFound} path="" />
      </Switch>
      {isAuthenticated && <Footer />}
    </>
  );
};

export default AppRouting;
